import { FileCardRemote } from "@/components/files";
import type { ExistingFileController } from "@/hooks/use-existing-file-controller";
import type { ResourceLinkController } from "@/hooks/use-resource-link-controller";
import { Collapser } from "@msuite/ui/collapser";
import { Divider } from "@msuite/ui/divider";
import { FileUpload, type FileUploadController } from "@msuite/ui/file-upload";
import { useTranslation } from "@msuite/ui/localization";
import type { TicketFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { TicketFormPendingResourceLinks } from "./ticket-form-pending-resource-links";
import { TicketFormResourceLinks } from "./ticket-form-resource-links";
import { TicketFormSelectExistingFiles } from "./ticket-form-select-existing-files";

/** Props Interface */
interface TicketFormAdvancedProps {
	controller: FileUploadController;
	ticketId?: string | null;
	resourceLinkController?: ResourceLinkController;
	existingFileController?: ExistingFileController;
}

export function TicketFormAdvanced({
	controller,
	ticketId,
	resourceLinkController,
	existingFileController,
}: TicketFormAdvancedProps) {
	/** Context */
	const methods = useFormContext<TicketFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const projectId = methods.watch("projectId");

	/** Render */
	return (
		<Collapser
			label={t("general.advanced")}
			defaultIsOpen
		>
			<FileUpload
				controller={controller}
				renderFile={(file) => (
					<FileCardRemote
						fileId={file.id}
						onInteraction={async () => {}}
					/>
				)}
			>
				<TicketFormSelectExistingFiles
					controller={controller}
					projectId={projectId}
					ticketId={ticketId}
					existingFileController={existingFileController}
				/>
			</FileUpload>
			{ticketId && projectId ? (
				<>
					<Divider variant="modal" />
					<TicketFormResourceLinks
						projectId={projectId}
						ticketId={ticketId}
					/>
				</>
			) : (
				resourceLinkController && (
					<>
						<Divider variant="modal" />
						<TicketFormPendingResourceLinks
							controller={resourceLinkController}
							projectId={projectId === "NULL" ? null : projectId}
						/>
					</>
				)
			)}
		</Collapser>
	);
}
